import { useCallback, useMemo } from 'react';
import { Vendor, VendorTrackingDetails, VendorActivateRequest } from './types';
import { useService } from '../common';

const API = {
    ADMIN_VENDOR_SEARCH: '/admin/vendor/search',
    VENDOR_LOGO: '/vendor/logo',
    VENDOR_SEARCH: '/vendor/search',
    VENDOR_ACTIVATE: '/vendor/activate'
};

export const useVendorService = ( isAdmin?: boolean) => {
    const service = useService();
    const searchVendors = useCallback((): Promise<Vendor[]> => {
        return service.sendGetWithAuthorization(isAdmin ? API.ADMIN_VENDOR_SEARCH : API.VENDOR_SEARCH)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service, isAdmin]);

    const getVendorLogo = useCallback(( uri: string): Promise<string> => {
        return service.sendGetWithAuthorization(`${API.VENDOR_LOGO}?uri=${uri}`)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    const activateVendor = useCallback(( request: VendorActivateRequest): Promise<VendorTrackingDetails> => {
        return service.sendPutWithAuthorization(API.VENDOR_ACTIVATE, request)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    return useMemo(() => ({
        activateVendor,
        getVendorLogo,
        searchVendors,
    }), [activateVendor, getVendorLogo, searchVendors]);
};